/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

if (!Element.prototype.matches)
  Element.prototype.matches = Element.prototype.msMatchesSelector;
if (!Element.prototype.closest)
  Element.prototype.closest = function (selector) {
    var el = this;
    while (el) {
      if (el.matches(selector)) {
        return el;
      }
      el = el.parentElement;
    }
  };

(function (Drupal, $) {
  Drupal.behaviors.mainMenu = {
    attach: function (context) {
      "use strict";

      // Use context instead of document IF DRUPAL.
      var toggle_expand = document.getElementById("toggle-expand");
      var menu = document.getElementById("main-nav");
      var expand_menu = menu.getElementsByClassName("expand-sub");

      var body = document.querySelector("body");
      var header = document.querySelector("header.header");
      var megaMenu = document.querySelector(".main-menu.level-1");
      var menuBack = menu.querySelectorAll(".main-menu__link--back");
      var menuItem = menu.querySelectorAll(
        ".main-menu.level-0 > .main-menu__item"
      );
      var menuItemLink = menu.querySelectorAll("a.main-menu__link");
      var menuOpen = false;

      if (!toggle_expand.classList.contains("click-events-added")) {
        // Mobile Menu Show/Hide.
        toggle_expand.addEventListener("click", function (e) {
          toggle_expand.classList.toggle("toggle-expand--open");
          menu.classList.toggle("main-nav--open");
          document.body.classList.toggle("main-nav-open");
          menuOpen = !menuOpen;

          if (menuOpen) {
            bodyScrollLock.disableBodyScroll(menu);
          } else {
            bodyScrollLock.enableBodyScroll(menu);
          }
        });

        // Expose mobile sub menu on click.
        for (var i = 0; i < expand_menu.length; i++) {
          expand_menu[i].addEventListener("click", function (e) {
            var menu_item = e.currentTarget;
            var sub_menu = null;
            var sibling = menu_item.nextElementSibling;
            while (sibling && sub_menu == null) {
              if (sibling.matches("ul")) sub_menu = sibling;
              sibling = sibling.nextElementSibling;
            }

            menu_item.classList.toggle("expand-sub--open");
            sub_menu.classList.toggle("main-menu--sub-open");
          });
        }
      }
      toggle_expand.classList.add("click-events-added");

      for (var i = 0; i < menuBack.length; i++) {
        menuBack[i].addEventListener("click", function (e) {
          e.target
            .closest(".main-menu--sub")
            .classList.remove("main-menu--sub-open");
          var expandSubs = menu.querySelectorAll(".expand-sub--open");
          for (var j = 0; j < expandSubs.length; j++) {
            expandSubs[j].classList.remove("expand-sub--open");
          }
        });
      }

      var timerId = null;
      for (var i = 0; i < menuItem.length; i++) {
        menuItem[i].addEventListener("mouseenter", function (e) {
          clearTimeout(timerId);
          body.classList.add("body-menu-hover");
          body.classList.remove("body-menu-hover-fade-out");
          header.classList.add("menu-hover");
          e.target.classList.add("is-hover");
          //bodyScrollLock.disableBodyScroll(megaMenu);
        });

        menuItem[i].addEventListener("mouseleave", function (e) {
          body.classList.add("body-menu-hover-fade-out");
          header.classList.remove("menu-hover");

          timerId = setTimeout(function (e) {
            body.classList.remove("body-menu-hover");
            body.classList.remove("body-menu-hover-fade-out");
            //bodyScrollLock.enableBodyScroll(megaMenu);
          }, 200);
        });
      }

      for (var i = 0; i < menuItemLink.length; i++) {
        menuItemLink[i].addEventListener("click", function () {
          // toggle_expand.click();
          var parentMenuItem = this.closest(".main-menu__item.is-hover");
          parentMenuItem.classList.add("no-pointer-events");
          setTimeout(function () {
            parentMenuItem.classList.remove("no-pointer-events");
          }, 1000);
        });
      }

      $("a.main-menu__link").each(function () {
        var $this = $(this);
        var link = $this.attr("href");
        if (window.location.href.indexOf(link.split("#")[0]) > -1) {
          var target = link.substring(link.indexOf("#"));
          $this.attr("href", target);
        }
      });

      document
        .querySelector(".menu-close")
        .addEventListener("click", function () {
          var parentMenuItem = this.closest(".main-menu__item");
          parentMenuItem.classList.add("no-pointer-events");
          setTimeout(function () {
            parentMenuItem.classList.remove("no-pointer-events");
          }, 1000);
        });
    },
  };
})(Drupal, jQuery);
